var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vis-container"},[_c('h2',{staticClass:"vis-title"},[_vm._v(_vm._s(_vm.songfinder.title))]),_c('p',{staticClass:"vis-text"},[_vm._v(_vm._s(_vm.songfinder.text))]),_c('SongFinder')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }